var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _line, _circle, _rect6, _rect7, _g, _rect8, _rect9, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ws-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5EAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EFDFC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ws-bench",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C9A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8C6C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ws-pane",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3FAF9",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFE0DD",
    stopOpacity: 0.55
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 400,
    rx: 20,
    fill: "url(#ws-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 290,
    width: 380,
    height: 18,
    fill: "url(#ws-bench)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 308,
    width: 16,
    height: 55,
    fill: "#6B5214"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 308,
    width: 16,
    height: 55,
    fill: "#6B5214"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 90,
    width: 160,
    height: 210,
    fill: "url(#ws-pane)",
    stroke: "#9E2430",
    strokeWidth: 4,
    transform: "rotate(-3 230 195)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 110 L200 270",
    stroke: "#ffffff",
    strokeWidth: 7,
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 150,
    x2: 380,
    y2: 110,
    stroke: "#4E3F37",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 107,
    r: 7,
    fill: "#9E2430"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 230,
    width: 60,
    height: 14,
    fill: "#C9A227"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 230,
    width: 14,
    height: 60,
    fill: "#C9A227"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DDB65C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 260,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 270,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 278,
    r: 2.5
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 34,
    height: 44,
    fill: "#821B26",
    stroke: "#DDB65C",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 70,
    width: 30,
    height: 38,
    fill: "#9E2430",
    stroke: "#DDB65C",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 345,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 15,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Crafted by Hand, Since Generations")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.5004d291441a5f3b130f837aefe11697.svg";
export { ForwardRef as ReactComponent };